import {
	createContext,
	useContext,
	useState,
	ReactNode,
	FC,
	useEffect,
} from "react";

export interface BreadcrumbItem {
	href: string;
	label: string;
}

interface BreadcrumbContextType {
	breadcrumbs: BreadcrumbItem[];
	updateBreadcrumbs: (newBreadcrumbs: BreadcrumbItem[]) => void;
}

const BreadcrumbContext = createContext<BreadcrumbContextType | undefined>(
	undefined,
);

interface BreadcrumbProviderProps {
	children: ReactNode;
}

export const BreadcrumbProvider: FC<BreadcrumbProviderProps> = ({
	children,
}) => {
	const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbItem[]>([]);

	const updateBreadcrumbs = (newBreadcrumbs: BreadcrumbItem[]) => {
		setBreadcrumbs(newBreadcrumbs);
	};

	return (
		<BreadcrumbContext.Provider value={{ breadcrumbs, updateBreadcrumbs }}>
			{children}
		</BreadcrumbContext.Provider>
	);
};

export const useBreadcrumb = () => {
	const context = useContext(BreadcrumbContext);
	if (context === undefined) {
		throw new Error("useBreadcrumb must be used within a BreadcrumbProvider");
	}
	return context;
};

export const useUpdateBreadcrumb = (breadcrumbs: BreadcrumbItem[]) => {
	const { updateBreadcrumbs } = useBreadcrumb();

	useEffect(() => {
		updateBreadcrumbs(breadcrumbs);
		return () => updateBreadcrumbs([]);
	}, [breadcrumbs, updateBreadcrumbs]);
};
